var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.extraClass || '') + ' textTimer title1 title1--2'},[_vm._v(" "+_vm._s(this.countDown)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }